/// <reference path="../types.d.ts" />
import { commonEnums } from '@codametrix/ui-common';
const { PermissionLevel } = commonEnums;
export const hasResource = (cmxContext, resourceName)=>{
    const { contexts } = cmxContext;
    return contexts.some((ctx)=>{
        return ctx.resources.some((resource)=>resource.resourceName === resourceName);
    });
};
export const checkResources = (actionGroups)=>{
    return actionGroups.some((group)=>group.options.some((option)=>option.enabled));
};
export const isTabViewOnly = (tabs, resourceName)=>{
    return tabs.find((tab)=>tab.resourceId === resourceName)?.permissionLevel === PermissionLevel.READ_ONLY;
};
export const isResourceViewOnly = (resources, resourceName)=>{
    return resources.find((resources)=>resources.resourceName === resourceName)?.permissionLevel === PermissionLevel.READ_ONLY;
};
export const isCaseConfigDeny = (userRoles, contextOrgName)=>{
    return !userRoles.find((role)=>role.organizationName === contextOrgName)?.roles.find((role)=>role.roleName === 'support_engineer' || role.roleName === 'professional_services');
};
